// Auto-close other categories when one is opened
const categoryDetails = document.querySelectorAll('.hyve-category-details');

categoryDetails.forEach(detail => {
    detail.addEventListener('toggle', function() {
        if (this.open) {
            categoryDetails.forEach(other => {
                if (other !== this && other.open) {
                    other.open = false;
                }
            });
        }
    });
});

// Auto-close other questions within the same category
const allCategories = document.querySelectorAll('.hyve-category-content');

allCategories.forEach(category => {
    const questions = category.querySelectorAll('.hyve-question-details');
    
    questions.forEach(question => {
        question.addEventListener('toggle', function() {
            if (this.open) {
                questions.forEach(other => {
                    if (other !== this && other.open) {
                        other.open = false;
                    }
                });
            }
        });
    });
});